<template>
  <div class="reset-form">
    <div class="mb-6">
      <div class="text-h6 text-md-h5 font-weight-black text-grey-darken-4" style="line-height: 1.2;">
        Recuperar contraseña
      </div>
      <div class="text-body-2 text-medium-emphasis mt-1">
        Ingresa tu email y te enviaremos un enlace para restablecerla.
      </div>
    </div>

    <v-form v-model="formvalidate">
      <div class="mb-3">
        <v-text-field
          v-model="restorepass.email"
          type="email"
          label="Email"
          placeholder="correo@cetemin.edu.pe"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
          bg-color="white"
          :rules="[rules.email, rules.required]"
        >
          <template v-slot:prepend-inner>
            <v-icon style="font-size: 14px; color: #9CA3AF;">fa:fa-regular fa-envelope</v-icon>
          </template>
        </v-text-field>
      </div>

      <div class="d-flex justify-space-between align-center mb-4">
        <v-btn
          variant="text"
          size="small"
          class="text-capitalize px-0"
          style="color: #005691; font-weight: 800;"
          @click="switchComponent('FormLoginComponent')"
        >
          Volver al login
        </v-btn>
      </div>

      <v-btn
        :disabled="!formvalidate"
        :loading="loadingsendmail"
        @click="getsendemailrestorepass()"
        elevation="0"
        block
        size="large"
        class="font-weight-black py-4 text-capitalize"
        style="background: linear-gradient(135deg, #002B49 0%, #005691 100%); color: white; border-radius: 14px;"
      >
        Enviar enlace
        <v-icon style="font-size: 14px; color: white; margin-left: 10px;">fa:fa-solid fa-paper-plane</v-icon>
      </v-btn>
    </v-form>

    <div class="d-flex justify-center mt-8">
      <v-img
        :src="require('@/assets/logo-tic.svg')"
        contain
        style="max-width: 140px; max-height: 28px; opacity: 0.85;"
      ></v-img>
    </div>
  </div>
</template>

<script>
import Filters from '@/modules/Shared/Filters';
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  mixins: [Filters],
  data() {
    return {
      formvalidate: true
    }
  },
  computed: {
    ...mapState('login', ['restorepass', 'loadingsendmail'])
  },
  methods: {
    ...mapMutations('login', ['switchComponent']),
    ...mapActions('login', ['getsendemailrestorepass'])
  }
}
</script>

<style scoped>
:deep(.v-field) {
  border-radius: 14px;
}
</style>

